import Merchant from "@/src/interfaces/merchant/merchant"
import { PaymentMethods } from "@/src/interfaces/system/payment-method"

export const usePaymentMethod = () => {
    const mapOfflinePayment = (payment: Merchant.PaymentConfiguration): PaymentMethods[] => {

        if (!payment.offinePaymentEnabled || !payment.offlineConfiguration?.paymentMethods)
            return []

        const paymentMethodsObjectList = payment.offlineConfiguration.paymentMethods?.reduce((acc, item) => {
            const key = item.typeId
            if (!acc[key]) acc[key] = []
            acc[key].push(item)
            return acc
        }, {} as Record<number, typeof payment.offlineConfiguration.paymentMethods>)


        let paymentMethodsList: PaymentMethods[] = []

        Object.keys(paymentMethodsObjectList).forEach((key) => {
            const paymentMethodsArray = paymentMethodsObjectList[Number.parseInt(key)];

            paymentMethodsArray?.forEach((item) => {
                let currentPaymentMethod = paymentMethodsList.find(c => c.typeId === item.typeId)

                const brand: Merchant.PaymentMethod = {
                    id: item.id,
                    typeId: item.typeId,
                    typeName: item.typeName,
                    brandId: item.brandId,
                    brandName: item.brandName
                }

                if (currentPaymentMethod) {
                    const alreadyHasBrand = currentPaymentMethod.brands.some(b => b.id === item.brandId)


                    if (!alreadyHasBrand) {
                        currentPaymentMethod.brands.push(brand)
                    }
                } else {
                    paymentMethodsList.push({
                        id: item.id,
                        typeId: item.typeId,
                        name: item.typeName,
                        brands: [brand]
                    })
                }
            })
        })

        return paymentMethodsList
    }

    return { mapOfflinePayment }
}